<!-- 电费账单结算弹窗 -->
<template>
  <dialogBody @confirm="confirm" @cancel="cancel" ref="body">
    <template slot="title">结算</template>
    <div style="padding-top: 15px;">
      <div class="formContainer">
        <label><span class="required">*</span>登录密码</label>
        <input type="password" v-model.trim="verifyPassword" autocomplete="new-password" placeholder="请输入登录密码" />
      </div>
      <div class="formContainer">
        <label><span class="required">*</span>支付金额</label>
        <input type="number" v-model="fee" min="0" placeholder="请输入支付金额" @keydown="keydownFloat($event)" />
      </div>
    </div>
  </dialogBody>
</template>

<script>
  import dialogBody from '@/components/module/dialog/dialogBody.vue'
  export default {
    components: {
      dialogBody
    },
    props: {

    },
    data () {
      return {
        callback: undefined,
        verifyPassword: '',
        fee: ''
      }
    },
    computed: {

    },
    watch: {},
    mounted () {},
    methods: {
      confirm () {
        if(this.verifyPassword==''||this.verifyPassword==undefined) {
          this.$dialogMethod.showMessage('登录密码为必填项')
          return
        }
        if(this.fee==''||this.fee==undefined) {
          this.$dialogMethod.showMessage('支付金额为必填项')
          return
        }
        if(this.callback!=undefined) {
          this.callback({fee: this.fee,password: hex_md5(this.verifyPassword)})
        }
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        this.verifyPassword=''
        this.fee=''
        this.$refs.body.hide()
      },
      open (callBack) {
        console.log(callBack);

        this.callback=callBack
        this.$refs.body.open()
      },
      keydownFloat (ev) {
        if(ev.keyCode==109||ev.keyCode==229) {
          ev.preventDefault()
        }
      },
    }
  }
</script>
<style scoped>
  .formContainer {
    margin-bottom: 12px;
  }

  .formContainer>label {
    min-width: 72px;
    text-align: right;
    display: inline-block;
    margin-right: 12px;
    line-height: 32px;
  }

  .formContainer>label>span {
    display: inline-block;
    width: 8px;
  }

  .required {
    color: red;
  }
</style>